var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Object3D',{attrs:{"obj":_vm.listener,"position":_vm.position}})}
var staticRenderFns = []

export { render, staticRenderFns }